import { render, staticRenderFns } from "./kdApprovalOperation.vue?vue&type=template&id=3b019760"
import script from "./kdApprovalOperation.vue?vue&type=script&lang=js"
export * from "./kdApprovalOperation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports